import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "toast-icon" }
const _hoisted_2 = { class: "toast-content" }
const _hoisted_3 = {
  key: 0,
  class: "toast-title"
}
const _hoisted_4 = { class: "toast-message" }

import { onMounted, onUnmounted, watch } from 'vue';
import {
    CheckCircleIcon,
    AlertCircleIcon,
    AlertTriangleIcon,
    InfoIcon,
    XIcon
} from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationToast',
  props: {
    show: {
        type: Boolean,
        default: false
    },
    message: {
        type: String,
        required: true
    },
    title: {
        type: String,
        default: ''
    },
    type: {
        type: String,
        default: 'info',
        validator: (value: string) => ['success', 'error', 'warning', 'info'].includes(value)
    },
    duration: {
        type: Number,
        default: 4000
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

let timer: ReturnType<typeof setTimeout> | null = null;

const setupTimer = () => {
    clearTimeout(timer!);
    if (props.show) {
        timer = setTimeout(() => emit('close'), props.duration);
    }
};

watch(() => props.show, (val) => {
    if (val) setupTimer();
    else clearTimeout(timer!);
});

onMounted(() => { if (props.show) setupTimer(); });
onUnmounted(() => clearTimeout(timer!));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "toast" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["notification-toast", __props.type])
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "toast-accent" }, null, -1)),
            _createElementVNode("div", _hoisted_1, [
              (__props.type === 'success')
                ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                    key: 0,
                    size: 20
                  }))
                : (__props.type === 'error')
                  ? (_openBlock(), _createBlock(_unref(AlertCircleIcon), {
                      key: 1,
                      size: 20
                    }))
                  : (__props.type === 'warning')
                    ? (_openBlock(), _createBlock(_unref(AlertTriangleIcon), {
                        key: 2,
                        size: 20
                      }))
                    : (_openBlock(), _createBlock(_unref(InfoIcon), {
                        key: 3,
                        size: 20
                      }))
            ]),
            _createElementVNode("div", _hoisted_2, [
              (__props.title)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1)
            ]),
            _createElementVNode("button", {
              class: "toast-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              "aria-label": "Закрыть"
            }, [
              _createVNode(_unref(XIcon), { size: 14 })
            ]),
            _createElementVNode("div", {
              class: "toast-progress",
              style: _normalizeStyle({ animationDuration: `${__props.duration}ms` })
            }, null, 4)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})